"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionTape = void 0;
const React = __importStar(require("react"));
const translation_hooks_1 = require("@hooks/translation.hooks");
const routing_hooks_1 = require("@hooks/routing.hooks");
const icons_1 = require("@shared-modules/components/icons");
const collection_card_1 = require("@components/collection-card");
const collection_hooks_1 = require("@hooks/collection.hooks");
require("./styles.scss");
const CollectionTape = () => {
    const { list: collections } = (0, collection_hooks_1.useCollections)({ sorting: "desc" }, { size: 8 });
    const exploreCollectionsRedirect = (0, routing_hooks_1.useRedirectTo)("/explore/collections", true);
    const translator = (0, translation_hooks_1.usePagesTranslation)("mainPage.collectionTape");
    return (React.createElement("div", { className: "c-main-page-collection-tape" },
        React.createElement("div", { className: "c-main-page-collection-tape__info" },
            React.createElement("div", { className: "c-main-page-collection-tape__title" }, translator("title")),
            React.createElement("div", { className: "c-main-page-collection-tape__description" }, translator("description")),
            React.createElement("div", { onClick: exploreCollectionsRedirect, className: "c-main-page-collection-tape__link" },
                translator("moreLink"),
                " ",
                React.createElement(icons_1.ArrowRight, { color: "red" }))),
        React.createElement("div", { className: "c-main-page-collection-tape__list" }, collections.map((collection) => (React.createElement(collection_card_1.CollectionCard, { key: collection.id, collection: collection }))))));
};
exports.CollectionTape = CollectionTape;
exports.default = exports.CollectionTape;
